<template>
    <slide-x-right-transition>
        <div v-if="!menuState && this.currentJourney" class="tracking-aside">
            <div class="tracking-aside__tabs">
                <side-menu mode="tab" :links="menuItems" style="margin-right: 50px;"></side-menu>
                <div class="tracking-aside__timeline">
                    <journey-timeline></journey-timeline>
                </div>
            </div>
            <div v-if="currentJourney != null" class="tracking-aside__main">
                <div class="tracking-aside__content">
                    <journey-list v-if="getActiveTrackingAsideTab === 'Journeys'" :current-journey="currentJourney" :is-hardware-online="isHardwareOnline"></journey-list>
                    <journey-videos v-else-if="getActiveTrackingAsideTab === 'Videos'" :current-journey="currentJourney" :is-hardware-online="isHardwareOnline"></journey-videos>
                    <journey-events v-else-if="getActiveTrackingAsideTab === 'Events'" :current-journey="currentJourney" :is-hardware-online="isHardwareOnline" :hardware-id="vehicle.hardwareId"></journey-events>
                    <vehicle-details v-else :current-journey="currentJourney" :is-hardware-online="isHardwareOnline"></vehicle-details>
                </div>

                <videos v-if="isStreamingHardware" v-model="isLivePreviewModal" ref="videos" :is-hardware-online="isHardwareOnline" :vehicle-uuid="vehicle.id" :hardware-id="vehicle.hardwareId" @isStreaming="onLiveStreaming"></videos>

                <remote-playback
                    v-if="vehicle && vehicle.deviceDetails"
                    :is-hardware-online="isHardwareOnline"
                    :vehicle-uuid="vehicle.id"
                    :is-streaming-hardware="isStreamingHardware"
                    :device-details="vehicle.deviceDetails"
                    :vehicle-id="vehicle.id"
                    ref="remotePlayback"
                ></remote-playback>
            </div>

            <sp-loader v-show="getIsTrackingAsideLoading"></sp-loader>
        </div>
    </slide-x-right-transition>
</template>

<script>
import SlideXRightTransition from '@/components/transitions/SlideXRightTransition'
import SideMenu from '@/components/layout/SideMenu/SideMenu'
import SideMenuObject from '@/components/layout/SideMenu/SideMenuItemObject'
import Journeys from '@/models/Journeys'
import JourneyList from '@/views/Tracking/components/Aside/JourneyDetails/JourneyList'
import JourneyVideos from '@/views/Tracking/components/Aside/JourneyVideos/JourneyVideos'
import JourneyEvents from '@/views/Tracking/components/Aside/JourneyEvents/JourneyEvents'
import VehicleDetails from '@/views/Tracking/components/Aside/VehicleDetails/VehicleDetails'
import SpLoader from '@/components/atoms/Loader'
import Videos from '@/views/Journeys/Videos'
import moment from 'moment';
import {mapActions, mapGetters} from 'vuex';
import JourneyTimeline from "@/views/Tracking/components/Aside/JourneyTimeline/JourneyTimeline";
import RemotePlayback from '@/views/Tracking/components/Aside/JourneyDetails/JourneyItem/RemotePlayback'

export default {
    name: 'Aside',
    components: {
        JourneyTimeline,
        JourneyVideos,
        JourneyList,
        JourneyEvents,
        VehicleDetails,
        SideMenu,
        SpLoader,
        SlideXRightTransition,
        Videos,
        RemotePlayback
    },
    props: {
        menuState: {
            type: [Boolean],
            required: true
        },
        currentJourney: {
            type: [Journeys, null],
            required: false
        }
    },
    created () {
        this.dateString = moment().format('YYYY-MM-DD')
    },
    beforeDestroy() {
        this.setActiveTrackingAsideTab('Journeys')
    },
    data () {
        return {
            isDatePickerShow: false,
            dateString: '',
            isLivePreviewModal: false,
            vehicle: null,
            devicesOnline: null,
            isHardwareOnline: false,
            videosCount: 0,
            eventsCount: 0,
        }
    },
    computed: {
        ...mapGetters({
            getActiveTrackingAsideTab: 'layoutModule/getActiveTrackingAsideTab',
            getIsTrackingAsideLoading: 'trackingModule/getIsTrackingAsideLoading',
            deviceStatistics: 'trackingModule/getDeviceStatistics',
            organizationLicense: 'activeOrganizationData/getOrganizationLicenses'
        }),
        isStreamingHardware () {
            if (!this.vehicle) {
                return false
            }

            return null != this.vehicle.hardwareId && ('0' === this.vehicle.hardwareId.charAt(0) || this.vehicle.deviceDetails.deviceProtocol.name == 'Howen')
        },
        getCurrentVehicle: {
            get () {
                return this.$store.state.trackingModule.currentVehicle
            },
            set (value) {
                this.$store.commit('trackingModule/setCurrentVehicle', value)
            }
        },
        menuItems () {
            const remotePlaybackLicense = this.checkRemotePlaybackStreamingLicense() && this.hasAllRoles(['StreamingPlayback'])
            const liveStreamingLicense = this.checkLiveStreamingLicense() && this.hasAllRoles(['StreamingLive'])
            const videosTab = this.checkMediaAccessibilityLicense() && this.hasAllRoles(['JourneysVideosTab'])
            const SideMenuList = [
                new SideMenuObject('map-regular', 'Journeys', 'tab'),
                new SideMenuObject('video-solid', 'Videos', 'tab', null, true, this.videosCount),
                new SideMenuObject('bell-solid', 'Events', 'tab', null, true, this.eventsCount),
                new SideMenuObject('truck-solid', 'Vehicle Details', 'tab')
            ]

            if (liveStreamingLicense) {
                SideMenuList.push(new SideMenuObject('play', 'Live View', 'action', null, true, false, () => {
                    this.$refs.videos.dialog = true
                }, !this.isHardwareOnline))
            }
            if (remotePlaybackLicense) {
                SideMenuList.push(new SideMenuObject('history-solid', 'Remote Playback', 'action', null, true, false, () => {
                    this.$refs.remotePlayback.isRemotePlaybackModal = true
                }, !this.isHardwareOnline))
            }
            if (!videosTab) {
                SideMenuList.splice(1, 1)
            }
            return SideMenuList
        }
    },
    watch: {
        currentJourney: {
            handler (newVal, oldVal) {
                if (!this.currentJourney) return

                this.adjustSideMenuTabCounters()
            },
            deep: true,
        },
        getCurrentVehicle: {
            handler (value) {
                this.vehicle = value
            },
            deep: true,
        },
        deviceStatistics: {
            handler () {
                if (null == this.deviceStatistics || !this.deviceStatistics.hasOwnProperty('devicesOnline') || !this.vehicle) {
                    return null
                }
                this.devicesOnline = this.deviceStatistics.devicesOnline
                this.isHardwareOnline = this.devicesOnline.includes(this.vehicle.hardwareId)

                this.vehicle.isHardwareOnline = this.isHardwareOnline

                this.setCurrentVehicle(this.vehicle)
            },
            deep: true
        },
    },
    methods: {
        adjustSideMenuTabCounters () {
            this.videosCount = this.currentJourney.medias.length
            this.eventsCount = this.currentJourney.events.length
        },
        onLiveStreaming (status) {
            this.isLivePreviewModal = !this.isLivePreviewModal
        },
        ...mapActions({
            setActiveTrackingAsideTab: 'layoutModule/setActiveTrackingAsideTab',
            setCurrentVehicle: 'trackingModule/setCurrentVehicle'
        }),
    }
}
</script>

<style scoped lang="scss">
.tracking-aside {
    &__header {
        width: 100%;
        margin-bottom: 10px;
        padding: 10px 15px;
    }

    &__vrn {
        font-weight: bold;
    }

    &__main {
        width: 100%;
        height: calc(100vh - #{get($header-config, default, height)});
        overflow: auto;
    }

    &__tabs {
        display: flex;
        flex-flow: row-reverse;
    }

    &__timeline {
        width: 50px;
        height: 100%;
        background: $inactive;
        position: fixed;
        z-index: 10;
    }
}
</style>
